import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { EntryPage } from '~/features/entries/entry-page';

/** An entry on a page of its own: the right panel's Open full page. */
function EntryFullPage(): ReactElement {
  const { recordId, entryId } = Route.useParams();
  return <EntryPage recordId={recordId} entryId={entryId} />;
}

export const Route = createFileRoute('/_app/records/$recordId/entries/$entryId/full')({
  component: EntryFullPage,
});
